module.exports = __webpack_public_path__ + "static/media/14.Ready,set,go.bcd2b47b.wav";